import { ReactNode, VFC } from 'react'
import { BreadCrumbProps } from 'src/components/BreadCrumb'
import { MemberHeader } from 'src/components/Header'
import { HEADER_HEIGHT } from 'src/components/Header/WideHeader/HeaderWrapper'
import { LoginUser } from 'src/models/User'
import styled from 'styled-components'
import { ProfileSideMenu } from './ProfileSideMenu'

type ProfileEditorWrapperProps = {
  user: LoginUser
  children: ReactNode
} & Partial<BreadCrumbProps>
export const ProfileEditorWrapper: VFC<ProfileEditorWrapperProps> = ({
  user,
  children,
}) => {
  return (
    <>
      <MemberHeader user={user} />
      <Content>
        <aside>
          <ProfileSideMenu
            isActiveScheduleUrl={!!user.company.isActiveScheduleUrl}
            isSalesDemoPlan={user.plan.salesDemo}
          />
        </aside>
        <section>{children}</section>
      </Content>
    </>
  )
}

const Content = styled.div`
  width: 100%;

  aside {
    width: 100%;
    min-width: 280px;
    background-color: #f6f6f6;
    padding-bottom: 10px;
  }

  @media screen and (min-width: 1276px) {
    display: flex;

    aside {
      width: 20%;
      min-height: 100vh;
    }

    section {
      width: 100%;
      margin-top: 40px;
    }

    > * {
      padding-top: ${HEADER_HEIGHT};
    }
  }
`
